import types from '../../config/types.js'
import MockServer from './MockServer.js'
import MockPagination from './MockPagination.js'
import ServerService from 'Services/ServerService.js'
import ServiceData from 'Mixins/ServiceData.js'

export default {
  mixins: [MockServer, ServiceData, MockPagination],
  data() {
    return {
      serverService: ServerService,
      searchTimeOut: null,
      filtersData: {},
      serverDeleteConfirm: {
        active: false,
      },
      serverDeleteLoading: false,
    }
  },
  computed: {
    filters() {
      return [
        {
          id: 'search',
          type: types.components.input,
          width: 5,
          attr: {
            placeholder: 'Поиск',
          },
        },
        {
          id: 'sip_server_ids',
          type: types.components.select,
          width: 4,
          attr: {
            placeholder: 'Все серверы',
            options: this.serverListOptions,
          },
        },
        {
          id: 'status',
          type: types.components.select,
          width: 3,
          attr: {
            placeholder: 'Все статусы',
            options: [
              {
                id: 1,
                label: 'Работает',
              },
              {
                id: 2,
                label: 'Не Работает',
              },
            ],
          },
        },
      ]
    },
    tableColumns() {
      return [
        {
          id: 'address',
          label: 'Адрес',
          onclick: () => {
            this.filtersData.order = 'host'
            this.toggleColumnOrderType(this.filtersData.order)
            this.getFilteredServers()
          },
          clickable: true,
          orderType: this.filtersData.order_type,
          selected: this.filtersData.order === 'host',
        },
        {
          id: 'subs',
          label: 'SIP-аккаунтов',
          onclick: () => {
            this.filtersData.order = 'contact_count'
            this.toggleColumnOrderType(this.filtersData.order)
            this.getFilteredServers()
          },
          clickable: true,
          orderType: this.filtersData.order_type,
          selected: this.filtersData.order === 'contact_count',
        },
        {
          id: 'status',
          label: 'Статус сервера',
          component: { type: 'chip' },
          onclick: () => {
            this.filtersData.order = 'status'
            this.toggleColumnOrderType(this.filtersData.order)
            this.getFilteredServers()
          },
          clickable: true,
          orderType: this.filtersData.order_type,
          selected: this.filtersData.order === 'status',
        },
      ]
    },
    tableRows() {
      const data = []

      this.serverList.forEach(server => {
        const health = this.serverHealthChecks[server.suid]
        let statusChip = null

        if (health) {
          statusChip = health.is_online
            ? {
                id: 'srvrwrks',
                type: 'completed',
                icon: 'check',
                label: 'Сервер работает',
              }
            : {
                id: 'srvrwrks',
                type: 'failed',
                icon: 'cross',
                label: 'Сервер не работает',
              }
        }

        data.push({
          id: server.suid,
          columns: [
            {
              id: 'address',
              content: {
                id: server.suid,
                label: server.host,
              },
            },
            {
              id: 'subs',
              content: {
                id: server.suid,
                label: server.user_contact_bindings_count,
              },
            },
            {
              id: 'status',
              content: {
                id: server.suid,
                chip: statusChip,
              },
            },
          ],
        })
      })

      return data
    },
    actions() {
      return {
        default: [
          {
            id: 2,
            type: types.actions.button,
            attr: {
              type: 'primary',
              label: 'Подключить адрес',
              icon: 'plus-outlined',
              handler: () => this.$router.push({ name: 'AddIntercom' }),
            },
          },
          {
            id: 3,
            type: types.actions.button,
            attr: {
              type: 'secondary',
              label: 'Добавить сервер',
              icon: 'plus-outlined',
              handler: () => this.$emit('addServer'),
            },
          },
        ],

        selected: [
          {
            id: 1,
            type: types.actions.text,
            label: `Выбрано элементов: ${this.rowsSelected.length}`,
          },
          {
            id: 2,
            type: types.actions.button,
            attr: {
              type: 'secondary',
              label: 'Отменить выделение',
              icon: 'cross',
              handler: () => (this.rowsSelected = []),
            },
          },
          {
            id: 3,
            type: types.actions.button,
            attr: {
              type: 'secondary',
              colored: 'danger',
              label: 'Удалить серверы',
              icon: 'trash',
              handler: () => {
                this.serverDeleteConfirm.active = true
              },
            },
          },
        ],
      }
    },
  },
  mounted() {
    if (this.serverList.length === 0) {
      this.getFilteredServers()
    } else {
      this.serverList.forEach(server => {
        this.getServerHealthCheck(server.suid)
      })
    }
  },
  methods: {
    toggleColumnOrderType(column) {
      this.filtersData.order_type =
        this.filtersData.order === column &&
        this.filtersData.order_type === 'asc'
          ? 'desc'
          : 'asc'
    },
    onRowClick(rowId) {
      this.$router.push({ name: 'Server', params: { serverId: rowId } })
    },
    removeSelectedRows() {
      this.serverDeleteLoading = true
      this.serverService
        .removeServers(this.rowsSelected)
        .then(response => {
          if (response.data.status) {
            this.getFilteredServers()
            this.rowsSelected = []
            this.serverDeleteConfirm.active = false
          }
        })
        .catch(error => {
          let msg = 'Сперва удалите домофоны серверов'
          this.$store.dispatch('setServerErrorMessage', msg)
          this.$store.dispatch('setNotification', {
            text: msg,
            type: 'cross-outlined',
          })
        })
        .finally(() => {
          this.serverDeleteLoading = false
        })
    },
    filterServers(filters) {
      const cleanedFilters = Object.entries(filters).reduce(
        (acc, [key, value]) => {
          if (value !== '' && value !== null && value !== undefined) {
            acc[key] = value
          }
          return acc
        },
        {}
      )

      this.filtersData = {
        ...cleanedFilters,
        page: 1,
        sip_server_ids: filters.sip_server_ids ? filters.sip_server_ids : '',
      }

      if (this.searchTimeOut) {
        clearTimeout(this.searchTimeOut)
      }

      this.searchTimeOut = setTimeout(async () => {
        await this.getFilteredServers()
      }, 500)
    },
    setServersPaginationSettings() {
      this.initPagination(
        this.serversMeta.current_page,
        this.serversMeta.total,
        this.serversMeta.per_page
      )
    },
    async onSwitchPage(page) {
      this.filtersData.page = page
      await this.getFilteredServers()
    },
    async getFilteredServers() {
      this.filtersData.organizationId = this.currentOrganizationId
      await this.getServers(this.filtersData)
      this.setServersPaginationSettings()
      this.serverList.forEach(server => {
        this.getServerHealthCheck(server.suid)
      })
    },
  },
}
